'use client';

import { isNumber } from 'lodash-es';
import { css } from 'styled-components';

import { Spacing } from '../constants/spacing';
import type { SpacingType } from './spacing';

/**
 * @deprecated This method is deprecated in favor of removing Styled-component. Use {@link spacingGenerator} instead;
 */
export const spacingHelper = (args: SpacingType) => css`
  // directional margin
  ${args.ml && `margin-left: ${isNumber(args.ml) ? args.ml : Spacing[args.ml]}rem`};
  ${args.mr && `margin-right: ${isNumber(args.mr) ? args.mr : Spacing[args.mr]}rem`};
  ${args.mb && `margin-bottom: ${isNumber(args.mb) ? args.mb : Spacing[args.mb]}rem`};
  ${args.mt && `margin-top: ${isNumber(args.mt) ? args.mt : Spacing[args.mt]}rem`};

  // horizontal margin
  ${args.mx &&
  (args.mx === 'auto'
    ? `margin-left: ${args.mx}; margin-right: ${args.mx};`
    : isNumber(args.mx)
      ? `margin-left: ${args.mx}rem; margin-right: ${args.mx}rem;`
      : `margin-left: ${Spacing[args.mx]}rem; margin-right: ${Spacing[args.mx]}rem;`)} // vertical margin
    ${args.my &&
  (isNumber(args.my)
    ? `margin-top: ${args.my}rem; margin-bottom: ${args.my}rem;`
    : `margin-top: ${Spacing[args.my]}rem; margin-bottom: ${Spacing[args.my]}rem;`)}

    // all direction margin
    ${args.m && `margin: ${isNumber(args.m) ? args.m : Spacing[args.m]}rem`};

  // directional padding
  ${args.pl && `padding-left: ${isNumber(args.pl) ? args.pl : Spacing[args.pl]}rem`};
  ${args.pr && `padding-right: ${isNumber(args.pr) ? args.pr : Spacing[args.pr]}rem`};
  ${args.pb && `padding-bottom: ${isNumber(args.pb) ? args.pb : Spacing[args.pb]}rem`};
  ${args.pt && `padding-top: ${isNumber(args.pt) ? args.pt : Spacing[args.pt]}rem`};

  // horizontal padding
  ${args.px &&
  (isNumber(args.px)
    ? `padding-left: ${args.px}rem; padding-right: ${args.px}rem;`
    : `padding-left: ${Spacing[args.px]}rem; padding-right: ${Spacing[args.px]}rem;`)} // vertical padding
    ${args.py &&
  (isNumber(args.py)
    ? `padding-top: ${args.py}rem; padding-bottom: ${args.py}rem;`
    : `padding-top: ${Spacing[args.py]}rem; padding-bottom: ${
        Spacing[args.py]
      }rem;`)} // all direction padding
    ${args.p && `padding: ${isNumber(args.p) ? args.p : Spacing[args.p]}rem`};
`;
